import styled from 'styled-components'

export const Container = styled.div`
    padding-top: 20px;
    padding-bottom: 40px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;
    min-width: 980px;
    max-width: 1305px;
    min-height: 600px;
`

export const TabContainer = styled.div`
    display: flex;
`

export const TabContent = styled.div`
    align-items: center;
    background-color: '#f5f5f5';
    padding: '10px 5px 0px 5px';
    width: 20%;
`

export const TabLabel = styled.div<{ icon?: string }>`
    ${({ icon }) =>
        icon &&
        `
        background-image: url("${icon}");
        background-position: center left;
        background-repeat: no-repeat;
        background-size: 14px;
        padding-left: 22px;
    `};
`

export const SectionNews = styled.div<{
    isRVDealer: boolean
}>`
    border: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    background-color: ${({ theme }) => theme.colors.monochrome.white};
    border-radius: 5px;
    display: flex;
    padding: 20px;
    justify-content: center;
    align-items: center;

    iframe {
        min-height: 520px;
        width: 100%;
        border: 0;
        overflow: hidden;

        ${({ isRVDealer }) => isRVDealer && `min-height: 560px;`}
    }
`
